$(document).ready(function(){

	$('.banners').initialiseCycle();
	
	banner_w = 1280;
	banner_h = 512;
	
	$(window).on('load resize ready orientationchange', function(){
		
		window_w = $(window).width();
					
		new_banner_h = (window_w / banner_w) * banner_h;
				
		$('li.banner, .banners li, .banners li div, .banners li a').height(new_banner_h).width(window_w);
		
	});
	
});
	
$.fn.initialiseCycle = function(){
	
	slideshow = this;
	
	options = {	'slides': 		'> li',
				'swipe': 		true,
				'speed': 		2000,
				'easing': 		'easeOutCirc',				
				'manualSpeed': 	500,
				'fx': 			'fade',
				'timeout':	 	8000,
				'next':   '.next', 
    			'prev':   '.prev' 
			  };
			  
	slideshow.cycle(options);
	
	slideshow.on('cycle-update-view', function(event, optionHash, slideOptionsHash, currentSlideEl){
		
		// the banner image is the div's CSS background - pull its URL out of url("...")
		filename = /url\(["']?(.*?)["']?\)/.exec($(currentSlideEl).find('div').css('background-image') || '');

		if (!filename) {
			return;
		}

		getImageLightness(filename[1], function(brightness){
			
			if(brightness >= 128)
			{
				//use dark arrows
				$('.banner > a').addClass('dark');
			}
			else
			{
				//use light arrows
				$('.banner > a').removeClass('dark');
			}
		});
		
	});
		
}

function getImageLightness(imageSrc,callback) {
    // the image is already loaded/cached as the banner's background, so this doesn't download it again
    var img = new Image();

    img.onload = function() {
        // sample a small scaled-down copy - the average brightness is the same, without looping over millions of pixels
        var canvas = document.createElement("canvas");
        canvas.width = 64;
        canvas.height = 26;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var colorSum = 0;

        for(var x = 0, len = data.length; x < len; x+=4) {
            colorSum += Math.floor((data[x] + data[x+1] + data[x+2]) / 3);
        }

        callback(Math.floor(colorSum / (canvas.width * canvas.height)));
    };

    img.src = imageSrc;
}
